'use client';

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQ_ITEMS = [
  {
    id: '0',
    question: 'Onde fica o escritório de advocacia John Bihuna?',
    answer:
      'O escritório está localizado na R. Maj. Livramento, 654 - Loja 3, Jardim Universitário, Biguaçu - SC, CEP 88161-036. Atendemos clientes de Biguaçu, Florianópolis, São José e Palhoça.',
  },
  {
    id: '1',
    question: 'Quais áreas de atuação o escritório atende?',
    answer:
      'Somos especializados em Direito Cível, Direito de Família, Direito Imobiliário, Direito Tributário, Direito Administrativo e Assessoria Jurídica para pessoas físicas e jurídicas em Biguaçu e toda Santa Catarina.',
  },
  {
    id: '2',
    question: 'Como entrar em contato com o advogado John Bihuna?',
    answer:
      'Você pode entrar em contato pelo WhatsApp (48) 99193-9567, pelo e-mail johnbihuna.advogados@gmail.com ou através do Instagram @johnbihuna.adv.',
  },
  {
    id: '3',
    question: 'O escritório atende em Florianópolis e outras cidades?',
    answer:
      'Sim, atendemos clientes em toda Santa Catarina, incluindo Biguaçu, Florianópolis, São José, Palhoça e demais municípios. Também atendemos clientes de outros estados do Brasil através de consultoria online.',
  },
  {
    id: '4',
    question: 'O escritório oferece atendimento remoto?',
    answer:
      'Sim, oferecemos atendimento presencial em nosso escritório em Biguaçu e atendimento remoto (online) para clientes de todo o Brasil. Entre em contato pelo WhatsApp (48) 99193-9567 para agendar.',
  },
];

export default function FaqSection() {
  const [openItems, setOpenItems] = useState<string[]>([]);

  const toggleItem = (id: string) => {
    if (openItems.includes(id)) {
      setOpenItems(openItems.filter((x) => x !== id));
    } else {
      setOpenItems([id]);
    }
  };

  return (
    <section className="flex justify-center w-full bg-[#FFFBF5]">
      <div className="flex flex-col px-5 py-10 lg:px-20 lg:py-20 lg:max-w-7xl mx-auto w-full">
        <h2 className="text-[#192437] text-lg font-bold tracking-widest mb-6">
          PERGUNTAS FREQUENTES
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {FAQ_ITEMS.map((item) => {
            const isOpen = openItems.includes(item.id);
            return (
              <AccordionItem
                key={item.id}
                value={item.id}
                className="rounded-xl shadow-sm mb-4 bg-white hover:opacity-80 transition"
              >
                <AccordionTrigger
                  className="text-base font-semibold px-6 py-3 hover:no-underline text-[#192437]"
                  onClick={() => toggleItem(item.id)}
                >
                  {item.question}
                </AccordionTrigger>
                <motion.div
                  initial={{ height: 0 }}
                  animate={{ height: isOpen ? 'auto' : 0 }}
                  transition={{ duration: 0.25, ease: 'linear' }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pt-0 pb-6">
                    <p className="text-primary text-sm text-justify font-medium">
                      {item.answer}
                    </p>
                  </div>
                </motion.div>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
}
